<script lang="ts">
  import Icon from '../Icon.svelte';
  import { ToastType } from './store.js';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let type: ToastType = 'info';
</script>

<div class="wrapper {type}">
  <slot />
  <button class="close-button" on:click={() => dispatch('dismiss')}>
    <Icon variant="close" />
  </button>
</div>

<style lang="scss">
  @use '../../styles/spacing';
  @use '../../styles/colors';

  .wrapper {
    background: colors.$white100;
    padding: spacing.$xs spacing.$s;
    border-radius: 4px;
  }

  .success {
    background-color: colors.$highlightGreen;
    color: colors.$white100;
  }

  .error {
    background-color: colors.$highlightRed;
    color: colors.$white100;
  }

  .info {
    border: 2px solid colors.$black60;
    border-radius: 4px;
  }

  .close-button {
    cursor: pointer;
  }
</style>
